import { getUrlSpecifiedParam } from '@/utils/tool'

export default {
  bind(el, binding) {
    if (!binding.value) return
    const eventObj = binding.value
    let channel = getUrlSpecifiedParam('channel')
    if (channel) {
      channel = '/' + channel
    }
    if (eventObj.type === 'click') {
      el.addEventListener('click', function() {
        console.log('统计事件上报', eventObj, channel)
        window._hmt?.push(['_trackEvent', eventObj.category + channel, eventObj.action, eventObj.opt_label || '', eventObj.opt_value || ''])
      })
    } else if (eventObj.type === 'visit') {
      window._hmt?.push(['_trackEvent', eventObj.category + channel, eventObj.action, eventObj.opt_label || '', eventObj.opt_value || ''])
    }
  }
}
